import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "create-component-list" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StyledUploader = _resolveComponent("StyledUploader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showImageUploader)
      ? (_openBlock(), _createBlock(_component_StyledUploader, {
          key: 0,
          onSuccess: _ctx.onImageUploaded
        }, null, 8, ["onSuccess"]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "component-item",
        onClick: ($event: any) => (_ctx.onItemClick(item))
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentName), _normalizeProps(_guardReactiveProps(item)), null, 16))
      ], 8, _hoisted_2))
    }), 128))
  ]))
}